<template>
    <div class="nav-user">
        <button @click="toggleBubble()">
            <div class="nav-user__name">
                <span class="h:hide-mobile">{{ fullName }}</span>
                <inline-svg
                    :url="require('../../../images/user_avatar.svg')"
                    classes="nav-user__avatar"
                ></inline-svg>
            </div>
        </button>

        <div class="nav-user__bubble">

            <div class="nav-user-bubble" v-show="showBubble">
                <div class="nav-user-bubble__arrow"></div>

                <a target="_blank" href="https://dekrasafetyweb.zendesk.com/hc/de" class="nav-user-bubble__link">
                    {{ trans('menu.support') }}

                    <svg class="nav-user-bubble__icon" width="30" height="30" viewBox="0 0 512 512"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="m512 346.5c0-63.535156-36.449219-120.238281-91.039062-147.820312-1.695313 121.820312-100.460938 220.585937-222.28125 222.28125 27.582031 54.589843 84.285156 91.039062 147.820312 91.039062 29.789062 0 58.757812-7.933594 84.210938-23.007812l80.566406 22.285156-22.285156-80.566406c15.074218-25.453126 23.007812-54.421876 23.007812-84.210938zm0 0" />
                        <path
                            d="m391 195.5c0-107.800781-87.699219-195.5-195.5-195.5s-195.5 87.699219-195.5 195.5c0 35.132812 9.351562 69.339844 27.109375 99.371094l-26.390625 95.40625 95.410156-26.386719c30.03125 17.757813 64.238282 27.109375 99.371094 27.109375 107.800781 0 195.5-87.699219 195.5-195.5zm-225.5-45.5h-30c0-33.085938 26.914062-60 60-60s60 26.914062 60 60c0 16.792969-7.109375 32.933594-19.511719 44.277344l-25.488281 23.328125v23.394531h-30v-36.605469l35.234375-32.25c6.296875-5.761719 9.765625-13.625 9.765625-22.144531 0-16.542969-13.457031-30-30-30s-30 13.457031-30 30zm15 121h30v30h-30zm0 0" />
                    </svg>
                </a>

                <a v-if="canImitateLogin" :href="route('tenant.users.imitate-back')" class="nav-user-bubble__link">
                    {{ trans('menu.imitate_back') }}

                    <svg class="nav-user-bubble__icon" width="30" height="30" viewBox="0 0 21 16" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20.49 8.50832L13.823 15.1753C13.2278 15.7706 12.196 15.3539 12.196 14.5007V10.691H6.79886C6.27106 10.691 5.84643 10.2663 5.84643 9.73854V5.92883C5.84643 5.40103 6.27106 4.9764 6.79886 4.9764H12.196V1.16669C12.196 0.317441 13.2238 -0.103215 13.823 0.492053L20.49 7.15905C20.8591 7.53208 20.8591 8.13529 20.49 8.50832ZM8.38624 14.9769V13.3895C8.38624 13.1276 8.17194 12.9133 7.91003 12.9133H4.57653C3.87411 12.9133 3.30662 12.3458 3.30662 11.6434V4.02397C3.30662 3.32156 3.87411 2.75407 4.57653 2.75407H7.91003C8.17194 2.75407 8.38624 2.53977 8.38624 2.27786V0.690475C8.38624 0.428557 8.17194 0.214261 7.91003 0.214261H4.57653C2.47325 0.214261 0.766815 1.9207 0.766815 4.02397V11.6434C0.766815 13.7467 2.47325 15.4531 4.57653 15.4531H7.91003C8.17194 15.4531 8.38624 15.2388 8.38624 14.9769Z" />
                    </svg>
                </a>

                <div class="nav-user-bubble__link">
                    <logout-link>
                        {{ trans('menu.logout') }}
                        <svg class="nav-user-bubble__icon" width="30" height="30" viewBox="0 0 21 16" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.49 8.50832L13.823 15.1753C13.2278 15.7706 12.196 15.3539 12.196 14.5007V10.691H6.79886C6.27106 10.691 5.84643 10.2663 5.84643 9.73854V5.92883C5.84643 5.40103 6.27106 4.9764 6.79886 4.9764H12.196V1.16669C12.196 0.317441 13.2238 -0.103215 13.823 0.492053L20.49 7.15905C20.8591 7.53208 20.8591 8.13529 20.49 8.50832ZM8.38624 14.9769V13.3895C8.38624 13.1276 8.17194 12.9133 7.91003 12.9133H4.57653C3.87411 12.9133 3.30662 12.3458 3.30662 11.6434V4.02397C3.30662 3.32156 3.87411 2.75407 4.57653 2.75407H7.91003C8.17194 2.75407 8.38624 2.53977 8.38624 2.27786V0.690475C8.38624 0.428557 8.17194 0.214261 7.91003 0.214261H4.57653C2.47325 0.214261 0.766815 1.9207 0.766815 4.02397V11.6434C0.766815 13.7467 2.47325 15.4531 4.57653 15.4531H7.91003C8.17194 15.4531 8.38624 15.2388 8.38624 14.9769Z" />
                        </svg>
                    </logout-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onKeyPress } from '../../util/onKeyPress';
import { onClickOutside } from '../../util/onClickOutside';
import InlineSvg from '../../util/inlineSvg.js';

export default {
    props: [
        'fullName',
        'canImitateLogin',
    ],

    components: {
        InlineSvg,
    },

    data() {
        return {
            showBubble: false,
        };
    },

    methods: {
        toggleBubble() {
            this.showBubble = !this.showBubble;
        },
        closeBubble() {
            this.showBubble = false;
        },
    },
    mounted() {
        onKeyPress('esc', this.closeBubble);

        onClickOutside(this.$el, this.closeBubble);
    },
};
</script>
